import {
    ChangeDetectorRef,
    Component,
    OnInit,
    inject,
  } from '@angular/core';
  import { CommonModule } from '@angular/common';
    import { FormsModule } from '@angular/forms';
  import { AuthService } from '../../services/auth.service';
  import { Student } from '../../interfaces/student.interfaces';
  import { AccreditationService } from '../../services/accreditation.service';
  import { FolioPillComponent } from '../ui/folio-pill/folio-pill.component';
  
  @Component({
    selector: 'app-my-accreditations',
    standalone: true,
    imports: [CommonModule, FormsModule, FolioPillComponent],
    templateUrl: './my-accreditations.html',
    styleUrl: './my-accreditations.scss',
  })
  export class MyAccreditationsComponent implements OnInit {
    protected readonly Math = Math;
    private authService = inject(AuthService);
    private accreditationService = inject(AccreditationService);
    private cdr = inject(ChangeDetectorRef);
  
    activities: Student['assignedActivities'] = [];
    accreditations: any[] = [];
    showCompletedActivities = false;
    // PAGINACIÓN DE ACTIVIDADES
    activitiesPage = 1;
    activitiesPageSize = 5;

    // PAGINACIÓN DE ACREDITACIONES
    accreditationsPage = 1;
    accreditationsPageSize = 5;

get pendingActivities(): Student['assignedActivities'] {
  return this.activities.filter(
    (activity) =>
      activity.status === 'registered' ||
      activity.status === 'attended'
  );
}

get completedActivities(): Student['assignedActivities'] {
  return this.activities.filter(
    (activity) =>
      activity.status === 'validated' ||
      activity.status === 'absent' ||
      activity.status === 'cancelled'
  );
}

get currentActivities(): Student['assignedActivities'] {
    const source = this.showCompletedActivities
      ? this.completedActivities
      : this.pendingActivities;
  
    const start = (this.activitiesPage - 1) * this.activitiesPageSize;
    const end = start + this.activitiesPageSize;
  
    return source.slice(start, end);
  }

  get activitiesTotalPages(): number {
    const total = this.showCompletedActivities
      ? this.completedActivities.length
      : this.pendingActivities.length;
  
    return Math.max(
      Math.ceil(total / this.activitiesPageSize),
      1,
    );
  }
  
  get activitiesPages(): number[] {
    return Array.from(
      { length: this.activitiesTotalPages },
      (_, index) => index + 1,
    );
  }
showHistory = false;

toggleActivitiesView(completed: boolean): void {
    this.showCompletedActivities = completed;
    this.activitiesPage = 1;
  }
  
  toggleAccreditationsView(history: boolean): void {
    this.showHistory = history;
    this.accreditationsPage = 1;
  }

get pendingAccreditations(): any[] {
  return this.accreditations.filter(
    (accreditation) => accreditation.status === 'pending'
  );
}

get historyAccreditations(): any[] {
  return this.accreditations.filter(
    (accreditation) =>
      accreditation.status === 'approved' ||
      accreditation.status === 'rejected'
  );
}

get currentAccreditations(): any[] {
    const source = this.showHistory
      ? this.historyAccreditations
      : this.pendingAccreditations;
  
    const start =
      (this.accreditationsPage - 1) *
      this.accreditationsPageSize;
  
    const end =
      start + this.accreditationsPageSize;
  
    return source.slice(start, end);
  }

  get accreditationsTotalPages(): number {
    const total = this.showHistory
      ? this.historyAccreditations.length
      : this.pendingAccreditations.length;
  
    return Math.max(
      Math.ceil(total / this.accreditationsPageSize),
      1,
    );
  }
  
  get accreditationsPages(): number[] {
    return Array.from(
      { length: this.accreditationsTotalPages },
      (_, index) => index + 1,
    );
  }

expandedAccreditationId: string | null = null;
    showNewAccreditationModal = false;
    successMessage = '';
    studentId = '';
    accreditationType = '';
    accreditationDate = '';
    eventType = '';
    hoursPerformed: number | null = null;
    quantity: number | null = null;
    participantsCount: number | null = null;
    reactionsCount: number | null = null;
    donationAmount: number | null = null;
    animalsEnrolled: number | null = null;
    infrastructureAvailable = false;
    evidenceUrl = '';
    comments = '';
  
    getAccreditationTypeLabel(type: string): string {
        const labels: Record<string, string> = {
          EVENT: 'Evento ABAQ',
          INDUCTION: 'Inducción',
          IDENTIFICATION: 'Placas de identificación',
          STERILIZATION: 'Esterilización',
          ADOPTION: 'Adopción',
          ADOPTION_MODULE: 'Módulo de adopción',
          TALK: 'Plática ABAQ',
          CAMPAIGN: 'Campaña',
          MEDIA: 'Difusión en medios',
          SOCIAL_MEDIA: 'Redes sociales',
          DONATION: 'Recaudación de fondos',
          ADMINISTRATIVE: 'Actividad administrativa',
        };
      
        return labels[type] ?? type;
      }
    ngOnInit(): void {
      this.authService.getUserInfo().subscribe({
        next: (student) => {
            if (!student) {
              return;
            }

            this.studentId = student.id;
          
            this.activities = student.assignedActivities ?? [];
          
            console.log(
              'ACTIVIDADES EN MIS ACREDITACIONES:',
              this.activities,
            );
          
            this.accreditationService
              .getStudentAccreditations(student.id)
              .subscribe({
                next: (response: any) => {
                  console.log(
                    'ACREDITACIONES DEL ESTUDIANTE:',
                    response,
                  );
          
                  this.accreditations =
                    response.data.documents ?? [];
          
                  this.cdr.detectChanges();
                },
          
                error: (error) => {
                  console.error(
                    'ERROR CARGANDO ACREDITACIONES:',
                    error,
                  );
          
                  this.accreditations = [];
          
                  this.cdr.detectChanges();
                },
              });
          },
  
        error: (error) => {
          console.error(
            'ERROR CARGANDO ACTIVIDADES:',
            error,
          );
  
          this.activities = [];
  
          this.cdr.detectChanges();
        },
      });
    }

    openNewAccreditationModal(): void {
        this.showNewAccreditationModal = true;
        this.cdr.detectChanges();
      }
      
    closeNewAccreditationModal(): void {
        this.showNewAccreditationModal = false;
        this.cdr.detectChanges();
      }

      toggleAccreditationDetails(accreditation: any): void {
        if (this.expandedAccreditationId === accreditation._id) {
          this.expandedAccreditationId = null;
        } else {
          this.expandedAccreditationId = accreditation._id;
        }
      
        this.cdr.detectChanges();
      }

      selectAccreditationType(): void {
        this.eventType = '';
        this.hoursPerformed = null;
        this.quantity = null;
        this.participantsCount = null;
        this.reactionsCount = null;
        this.donationAmount = null;
        this.animalsEnrolled = null;
        this.infrastructureAvailable = false;
        this.evidenceUrl = '';
        this.comments = '';
      }

      isAccreditationFormValid(): boolean {
        if (!this.accreditationType || !this.accreditationDate) {
          return false;
        }
      
        switch (this.accreditationType) {
          case 'EVENT':
            return (
              !!this.eventType &&
              this.hoursPerformed !== null &&
              this.hoursPerformed > 0
            );
      
          case 'IDENTIFICATION':
          case 'STERILIZATION':
          case 'ADOPTION':
          case 'ADOPTION_MODULE':
            return (
              this.quantity !== null &&
              this.quantity > 0
            );
      
          case 'TALK':
            return (
              this.participantsCount !== null &&
              this.participantsCount > 0
            );
      
          case 'CAMPAIGN':
            return (
              this.animalsEnrolled !== null &&
              this.animalsEnrolled > 0
            );
      
          case 'SOCIAL_MEDIA':
            return (
              this.reactionsCount !== null &&
              this.reactionsCount >= 0
            );
      
          case 'DONATION':
            return (
              this.donationAmount !== null &&
              this.donationAmount > 0
            );
      
          case 'ADMINISTRATIVE':
            return (
              this.hoursPerformed !== null &&
              this.hoursPerformed > 0
            );
      
          default:
            return true;
        }
      }


      createAccreditation(): void {
        if (!this.isAccreditationFormValid()) {
          return;
        }
      
        const [year, month, day] = this.accreditationDate
        .split('-')
        .map(Number);

        const selectedDate = new Date(
        year,
        month - 1,
        day,
        12,
        0,
        0,
        );

        const data: any = {
        studentRef: this.studentId,
        type: this.accreditationType,
        date: selectedDate.toISOString(),
        evidenceUrl: this.evidenceUrl,
        comments: this.comments,
        };
      
        if (this.accreditationType === 'EVENT') {
          data.eventType = this.eventType;
          data.hoursPerformed = this.hoursPerformed;
        }
      
        if (
          this.accreditationType === 'IDENTIFICATION' ||
          this.accreditationType === 'STERILIZATION' ||
          this.accreditationType === 'ADOPTION' ||
          this.accreditationType === 'ADOPTION_MODULE'
        ) {
          data.quantity = this.quantity;
        }
      
        if (this.accreditationType === 'TALK') {
          data.participantsCount = this.participantsCount;
        }
      
        if (this.accreditationType === 'CAMPAIGN') {
          data.animalsEnrolled = this.animalsEnrolled;
          data.infrastructureAvailable =
            this.infrastructureAvailable;
        }
      
        if (this.accreditationType === 'SOCIAL_MEDIA') {
          data.reactionsCount = this.reactionsCount;
        }
      
        if (this.accreditationType === 'DONATION') {
          data.donationAmount = this.donationAmount;
        }
      
        if (this.accreditationType === 'ADMINISTRATIVE') {
            data.hoursPerformed = this.hoursPerformed;
            data.hoursAccredited = this.hoursPerformed;
          }
      
        console.log(
          'SOLICITUD DE ACREDITACIÓN:',
          data,
        );
      
        this.accreditationService
          .createAccreditation(data)
          .subscribe({
            next: (response) => {
              console.log(
                'ACREDITACIÓN CREADA:',
                response,
              );
      
              this.closeNewAccreditationModal();
              this.successMessage =
  '✓ Solicitud enviada correctamente. ABAQ revisará tu acreditación.';
  
              this.accreditationService
                .getStudentAccreditations(this.studentId)
                .subscribe({
                  next: (accreditationResponse: any) => {
                    this.accreditations =
                      accreditationResponse.data.documents ?? [];
      
                    this.cdr.detectChanges();
                  },
                });

                setTimeout(() => {
                    this.successMessage = '';
                    this.cdr.detectChanges();
                  }, 5000);
            },
      
            error: (error) => {
              console.error(
                'ERROR CREANDO ACREDITACIÓN:',
                error,
              );
            },
          });
      }

      goToActivitiesPage(page: number): void {
        if (
          page < 1 ||
          page > this.activitiesTotalPages
        ) {
          return;
        }
      
        const scrollPosition = window.scrollY;
      
        this.activitiesPage = page;
        this.cdr.detectChanges();
      
        requestAnimationFrame(() => {
          window.scrollTo({
            top: scrollPosition,
            behavior: 'auto',
          });
        });
      }
      
      previousActivitiesPage(): void {
        this.goToActivitiesPage(
          this.activitiesPage - 1,
        );
      }
      
      nextActivitiesPage(): void {
        this.goToActivitiesPage(
          this.activitiesPage + 1,
        );
      }
      
      goToAccreditationsPage(page: number): void {
        if (
          page < 1 ||
          page > this.accreditationsTotalPages
        ) {
          return;
        }
      
        this.accreditationsPage = page;
        this.cdr.detectChanges();
      }
      
      previousAccreditationsPage(): void {
        this.goToAccreditationsPage(
          this.accreditationsPage - 1,
        );
      }
      
      nextAccreditationsPage(): void {
        this.goToAccreditationsPage(
          this.accreditationsPage + 1,
        );
      }

  }